module.exports = __webpack_public_path__ + "img/Sokal-Toyota-SRS-112221-Established.50f1fbc0.jpeg";